import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import './SettingsPage.css';

function ManageSubscriptions() {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(null);

  useEffect(() => {
    api.get('/api/user/subscriptions').then(res => {
      setSubscriptions(res.data?.subscriptions || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const handleAction = async (subId, action) => {
    setActionLoading(`${subId}-${action}`);
    try {
      await api.post(`/api/user/subscriptions/${subId}/${action}`);
      // Reload
      const res = await api.get('/api/user/subscriptions');
      setSubscriptions(res.data?.subscriptions || []);
    } catch (err) {
      alert(err.response?.data?.error || `Failed to ${action}`);
    }
    setActionLoading(null);
  };

  const statusColor = (state) => {
    switch (state) {
      case 'active': return '#10b981';
      case 'past_due': return '#fbbf24';
      case 'expired': case 'cancelled': return '#ef4444';
      default: return '#aaa';
    }
  };

  return (
    <div className="settings-page-content">
      <h2>Manage Subscriptions</h2>
      <p className="page-description">View and manage your club subscriptions.</p>

      {loading ? (
        <p style={{ color: '#aaa' }}>Loading subscriptions...</p>
      ) : subscriptions.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">💳</div>
          <h3>No Active Subscriptions</h3>
          <p>You're not subscribed to any clubs yet. Join a club to start a subscription.</p>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: 16 }}>
          {subscriptions.map(sub => (
            <div key={sub.id} style={{
              background: 'rgba(0,0,0,0.25)', borderRadius: 10, padding: 20,
              border: '1px solid rgba(255,255,255,0.05)'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
                <div>
                  <h3 style={{ color: '#fff', margin: '0 0 4px', fontSize: 16 }}>
                    {sub.clubName || `Club #${sub.clubId}`}
                  </h3>
                  <span style={{ color: statusColor(sub.state), fontSize: 12, fontWeight: 600, textTransform: 'uppercase' }}>
                    {sub.state}
                  </span>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ color: '#fff', fontSize: 20, fontWeight: 700 }}>
                    ${(sub.amountInCents / 100).toFixed(2)}
                  </div>
                  <div style={{ color: '#aaa', fontSize: 12 }}>{sub.frequency || 'weekly'}</div>
                </div>
              </div>

              <div style={{ display: 'flex', gap: 20, color: '#aaa', fontSize: 13, marginBottom: 12 }}>
                {sub.nextPaymentDate && <span>Next payment: {new Date(sub.nextPaymentDate).toLocaleDateString()}</span>}
                {sub.failedAttemptsInARow > 0 && (
                  <span style={{ color: '#ef4444' }}>Failed attempts: {sub.failedAttemptsInARow}/8</span>
                )}
              </div>

              <div style={{ display: 'flex', gap: 8 }}>
                {sub.state === 'active' && (
                  <button onClick={() => handleAction(sub.id, 'cancel')}
                    disabled={actionLoading === `${sub.id}-cancel`}
                    style={{ padding: '6px 16px', background: '#7f1d1d', color: '#ef4444', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>
                    {actionLoading === `${sub.id}-cancel` ? 'Cancelling...' : 'Cancel Subscription'}
                  </button>
                )}
                {(sub.state === 'cancelled' || sub.state === 'expired') && (
                  <button onClick={() => handleAction(sub.id, 'resume')}
                    disabled={actionLoading === `${sub.id}-resume`}
                    style={{ padding: '6px 16px', background: '#065f46', color: '#10b981', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>
                    {actionLoading === `${sub.id}-resume` ? 'Resuming...' : 'Resume Subscription'}
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ManageSubscriptions;
